import type { MenuCategory } from '@cracked-mug/shared';
import { cn } from '../../lib/cn';

interface CategoryNavProps {
  categories: MenuCategory[];
  activeId: string | null;
  onSelect: (categoryId: string) => void;
}

/** Sticky pill nav. Tap a chip to scroll to that category. */
export function CategoryNav({ categories, activeId, onSelect }: CategoryNavProps) {
  return (
    <nav
      // Sticks just under the header. Add the iOS safe-area inset so it stays
      // aligned with the header (which is also offset by it) in standalone mode.
      className="sticky z-20 bg-wca-chalk border-b border-wca-gray-light overflow-x-auto"
      style={{ top: 'calc(60px + env(safe-area-inset-top))' }}
    >
      <ul className="flex gap-2 px-4 py-3 sm:px-6 min-w-fit">
        {categories
          .filter((c) => c.isActive)
          .map((cat) => (
            <li key={cat.categoryId}>
              <button
                type="button"
                onClick={() => onSelect(cat.categoryId)}
                className={cn(
                  'flex min-h-[40px] items-center gap-1.5 whitespace-nowrap rounded-full px-4 text-sm font-medium transition-all',
                  activeId === cat.categoryId
                    ? 'bg-wca-red text-white shadow-[0_4px_12px_-4px_rgba(196,18,48,0.5)]'
                    : 'border border-wca-gray-light bg-wca-surface text-wca-black hover:border-wca-red/40 hover:text-wca-red',
                )}
              >
                {cat.icon.length > 0 && <span aria-hidden="true">{cat.icon}</span>}
                {cat.name}
              </button>
            </li>
          ))}
      </ul>
    </nav>
  );
}
